import * as icons from "react-bootstrap-icons";
import { renderToStaticMarkup } from "react-dom/server";

export type ReactBootstrapIconNames = keyof typeof icons;
export interface IconProps extends icons.IconProps {
  // Cannot use "name" as it is a valid SVG attribute
  // "iconName", "filename", "icon" will do it instead
  iconName: ReactBootstrapIconNames;
}
export const BootstrapIcon = ({ iconName, ...props }: IconProps) => {
  const BootstrapIcon = icons[iconName];
  return <BootstrapIcon {...props} />;
};

const iconNames = Object.keys(icons) as ReactBootstrapIconNames[];

export const AllHeaderIconsRecordForTable: Record<
  string,
  (spriteProps: { fgColor: string; bgColor: string }) => string
> = iconNames.reduce(
  (
    acc: Record<
      string,
      (spriteProps: { fgColor: string; bgColor: string }) => string
    >,
    iconName
  ) => {
    acc[iconName] = ({ fgColor, bgColor }) =>
      renderToStaticMarkup(
        <BootstrapIcon iconName={iconName} color={bgColor} />
      );
    return acc;
  },
  {}
);
